import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { injectModalRef } from '../../../../shared/modal';
import { SettingsService } from '../../../../core/services';
import { apiErrorMessage } from '../../../../core/utils/api-error-message';

@Component({
  selector: 'app-disable-two-factor-modal',
  standalone: false,
  templateUrl: './disable-two-factor-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisableTwoFactorModal {
  readonly modalRef = injectModalRef<boolean>();

  private readonly settingsService = inject(SettingsService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly code = new FormControl('', { nonNullable: true, validators: [Validators.required] });
  protected readonly submitting = signal(false);
  protected readonly error = signal<string | null>(null);

  protected submit(): void {
    if (this.submitting()) return;
    if (this.code.invalid) {
      this.code.markAsTouched();
      return;
    }

    this.submitting.set(true);
    this.error.set(null);
    this.modalRef.setDisableClose(true);

    this.settingsService.disableTwoFactor(this.code.value.trim())
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.submitting.set(false);
          this.modalRef.setDisableClose(false);
        }),
      )
      .subscribe({
        next: () => this.modalRef.close(true),
        error: error => this.error.set(apiErrorMessage(error, 'That code did not work. Please try again.')),
      });
  }
}
